import '../../vendors/layer_handler_ecc/layer_handler_eec'

// Utilidades de visibilidad (vanilla, sin :visible de jQuery)
function isVisible(el) {
  if (!el) return false
  if (el.hasAttribute('hidden')) return false
  const style = window.getComputedStyle(el)
  if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') return false
  if (!el.getClientRects().length) return false
  return true
}

// Devuelve todos los tabs (role="tab") dentro del mismo contenedor .js-tabs
function getTabsFromContainer(container) {
  return Array.from(container.querySelectorAll('[role="tab"]'))
}

// Panel asociado a un tab (preferimos aria-controls)
function getPanelForTab(tab) {
  const byAria = tab.getAttribute('aria-controls')
  if (byAria) return document.getElementById(byAria)
  // fallback: data-tab en el li contenedor
  const li = tab.closest('.js-tabs-nav-list-item')
  const dataTab = li?.getAttribute('data-tab')
  return dataTab ? document.querySelector(dataTab) : null
}

/**
 * Activa pestaña y panel (ARIA + foco + clases + hidden) dentro de un .js-tabs
 * @param {HTMLElement} container  contenedor del componente (.js-tabs)
 * @param {HTMLElement} activeTab  botón con role="tab"
 * @param {HTMLElement} activePanel  panel con role="tabpanel"
 */
function changeTab(container, activeTab, activePanel) {
  if (!container || !activeTab || !activePanel) return

  const tabs = getTabsFromContainer(container)

  tabs.forEach(tab => {
    const panel = getPanelForTab(tab)
    const isActive = tab === activeTab

    // Tabs
    tab.classList.toggle('active', isActive)
    tab.setAttribute('aria-selected', isActive ? 'true' : 'false')
    tab.setAttribute('tabindex', isActive ? '0' : '-1')

    // Paneles
    if (panel) {
      panel.classList.toggle('active', isActive)
      if (isActive) panel.removeAttribute('hidden')
      else panel.setAttribute('hidden', '')
    }
  })

  // Foco al tab activado
  activeTab.focus()

  // Swiper: actualizar contenedores visibles del panel
  activePanel.querySelectorAll('.swiper-container').forEach(swiperContainer => {
    if (swiperContainer.swiper && isVisible(swiperContainer)) {
      swiperContainer.swiper.update()
    }
  })

  // ECC visible products (si está disponible)
  if (typeof LayerHandlerEec !== 'undefined' && LayerHandlerEec?.pushVisibleProducts) {
    LayerHandlerEec.pushVisibleProducts(
      '.destination-tabs-list .js-tab.active .js-tab.active .card-container .call-to-action a[data-ecc-product]'
    )
  }
}

/* -------------------- Delegación de eventos -------------------- */

// Click en pestañas del nav
document.addEventListener('click', function (e) {
  // Scope: componente .js-tabs más cercano
  const container = e.target.closest('.js-tabs')
  if (!container) return

  // ¿Click en el tab (role="tab") o en su item del nav?
  const tabFromClick = e.target.closest('[role="tab"]')
  const navItem = tabFromClick || e.target.closest('.js-tabs-nav .js-tabs-nav-item, .js-tabs-nav-list-item')
  if (!navItem) return

  e.preventDefault()

  // Normalizar: obtén siempre el <button role="tab">
  const tab = tabFromClick || navItem.querySelector('[role="tab"]')
  if (!tab || !container.contains(tab)) return

  // Panel por aria-controls o por data-tab en <li>
  let panel = getPanelForTab(tab)
  if (!panel) {
    const li = tab.closest('.js-tabs-nav-list-item')
    const dataTab = li?.getAttribute('data-tab')
    if (dataTab) panel = container.querySelector(dataTab)
  }
  if (!panel) return

  changeTab(container, tab, panel)
})

// Click en enlaces que cambian de pestaña (.js-link-nav)
document.addEventListener('click', function (e) {
  const link = e.target.closest('.js-link-nav')
  if (!link) return

  const container = link.closest('.js-tabs-parent')?.querySelector('.js-tabs') || document.querySelector('.js-tabs')
  if (!container) return

  e.preventDefault()
  const dataTab = link.getAttribute('data-tab')
  if (!dataTab) return

  const panel = container.querySelector(dataTab)
  if (!panel) return

  const byAria = container.querySelector(`[role="tab"][aria-controls="${panel.id}"]`)
  const byData = container.querySelector(`.js-tabs-nav [data-tab="${dataTab}"] [role="tab"]`)
  const tab = byAria || byData
  if (!tab) return

  changeTab(container, tab, panel)
})

// Acciones de estilo/clase extra (.js-tabs-actions li)
document.addEventListener('click', function (e) {
  const actionLi = e.target.closest('.js-tabs-actions li')
  if (!actionLi) return

  const container = actionLi.closest('.js-tabs')
  if (!container) return

  e.preventDefault()

  const klass = actionLi.getAttribute('data-klass') || ''

  actionLi.classList.add('active')
  Array.from(actionLi.parentElement.children).forEach(sibling => {
    if (sibling !== actionLi) sibling.classList.remove('active')
  })

  container.className = `js-tabs ${klass}`.trim()

  container.querySelectorAll('.swiper-container').forEach(swiperContainer => {
    if (swiperContainer.swiper) swiperContainer.swiper.update(true)
  })
})

/* Navegación por teclado: */
document.addEventListener('keydown', function (e) {
  const currentTab = e.target.closest('[role="tab"]')
  if (!currentTab) return

  const container = currentTab.closest('.js-tabs')
  if (!container) return

  const tabs = getTabsFromContainer(container)
  const idx = tabs.indexOf(currentTab)
  if (idx === -1) return

  let nextIdx = null
  switch (e.key) {
    case 'ArrowRight':
      nextIdx = Math.min(idx + 1, tabs.length - 1)
      break
    case 'ArrowLeft':
      nextIdx = Math.max(idx - 1, 0)
      break
    case 'Home':
      nextIdx = 0
      break
    case 'End':
      nextIdx = tabs.length - 1
      break
    default:
      return
  }

  e.preventDefault()
  const nextTab = tabs[nextIdx]
  const nextPanel =
    getPanelForTab(nextTab) ||
    nextTab
      .closest('.js-tabs')
      ?.querySelector(nextTab.closest('.js-tabs-nav-list-item')?.getAttribute('data-tab') || '')
  if (nextPanel) changeTab(container, nextTab, nextPanel)
})
